
import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { postData } from "../../../../../ApiServices/ApiService";
import { logFrontendException } from "../../../../../Utils/Exception";
import { ORG_INVOICE_PAYMENT_CONFIGURATION } from "../../../../../ApiServices/BaseURL";
import { useTheme } from "../../../../../GlobalContext/GlobalContext";

const InvoicePaymentGatewayController = (paymentData, paymentLoading, paymentError, onRefresh) => {
    const [pgApiKeyId, setPgApiKeyId] = useState('');
    const [pgApiSecretKey, setPgApiSecretKey] = useState('');

    const [saveLoading, setSaveLoading] = useState(false);
    const [saveError, setSaveError] = useState('');
    const [success, setSuccess] = useState('');

    const [pgApiKeyIdError, setPgApiKeyIdError] = useState('');
    const [pgApiSecretKeyError, setPgApiSecretKeyError] = useState('');

    const [showPgApiKeyId, setShowPgApiKeyId] = useState(false);
    const [showPgApiSecretKeyId, setShowPgApiSecretKeyId] = useState(false);

    const navigator = useNavigate();

    const { setIsLoginPopup } = useTheme();

    const pageName = "InvoicePaymentGatewayController";

    useEffect(() => {
        if (paymentData) {
            setPgApiKeyId(paymentData?.pg_api_key_id || '');
            setPgApiSecretKey(paymentData?.pg_secret_key || '');
        }
        setSaveError(paymentError);
        setSaveLoading(paymentLoading);
    }, [paymentData, paymentError, paymentLoading]);

    const toggleShowApiKey = () => {
        setShowPgApiKeyId(!showPgApiKeyId);
    };

    const toggleShowApiSecretKey = () => {
        setShowPgApiSecretKeyId(!showPgApiSecretKeyId);
    };

    const savePaymentConfig = async () => {
        setSaveLoading(true);
        setSaveError('');
        setSuccess('');
        setPgApiKeyIdError('');
        setPgApiSecretKeyError('');
        setShowPgApiKeyId(false);
        setShowPgApiSecretKeyId(false);

        const storedUser = JSON.parse(localStorage.getItem("_userInfo_"));

        // Validate required fields
        if (pgApiKeyId.trim().length === 0 || pgApiKeyId.trim().length > 50) {
            setPgApiKeyIdError("Payment API Key must be 1–50 characters.");
            setSaveLoading(false);
            return;
        }
        // if (!/^[A-Za-z0-9-_\.]+$/.test(pgApiKeyId)) {
        //     setPgApiKeyIdError("Access Token contains invalid characters.");
        //     setSaveLoading(false);
        //     return;
        // }
        if (pgApiSecretKey.trim().length === 0 || pgApiSecretKey.trim().length > 50) {
            setPgApiSecretKeyError("Payment Secret Key must be 1–50 characters.");
            setSaveLoading(false);
            return;
        }

        const payload = {
            action_type: paymentData ? "update_payment_config" : "add_payment_config",
            emp_id_auth: storedUser?.emp_id,
            pg_name: "Razorpay",
            pg_api_key_id: pgApiKeyId,
            pg_secret_key: pgApiSecretKey,
        };

        console.log("peyload", payload)

        try {
            const response = await postData(ORG_INVOICE_PAYMENT_CONFIGURATION, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.status_code === 200) {
                    if (responseData?.message?.toLowerCase() === "success") {
                        setSuccess(responseData?.info || "Payment configuration updated successfully.");
                        setTimeout(() => {
                            onRefresh();
                            setSuccess('');
                        }, 3000);
                    } else {
                        setSaveError(responseData?.info || "Unable to add/update payment configuration.");
                        logFrontendException(storedUser?.emp_id, pageName, "savePaymentConfig", responseData?.info);
                    }
                } else {
                    setSaveError(responseData?.info || "Unable to add/update payment configuration.Please try again.");
                    logFrontendException(storedUser?.emp_id, pageName, "savePaymentConfig", responseData);
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setSaveError('Unauthorized access. Your session may have expired. Please log in again.');
                setIsLoginPopup(true)
                logFrontendException(storedUser?.emp_id, pageName, 'savePaymentConfig-Unauthorized', response || '');
            } else {
                setSaveError("Failed to add/update payment configuration.");
                logFrontendException(storedUser?.emp_id, pageName, "savePaymentConfig", response);
            }
        } catch (error) {
            setSaveError("Failed to add/update payment configuration.Please Check your internet connection and try again.");
            logFrontendException(storedUser?.emp_id, pageName, "savePaymentConfig-catch", error);
        } finally {
            setSaveLoading(false);
        }
    };

    const handleCancel = () => {
        navigator('/dashboard');
    }

    return {
        pgApiKeyId,
        setPgApiKeyId,
        pgApiSecretKey,
        setPgApiSecretKey,
        saveLoading,
        saveError,
        success,
        savePaymentConfig,
        pgApiSecretKeyError,
        setPgApiSecretKeyError,
        pgApiKeyIdError,
        setPgApiKeyIdError,
        handleCancel,
        toggleShowApiKey,
        showPgApiKeyId,
        toggleShowApiSecretKey,
        showPgApiSecretKeyId,
    }
}
export default InvoicePaymentGatewayController;